import { render } from "./ImageInfo.vue?vue&type=template&id=b8eb540e&scoped=true"
import script from "./ImageInfo.vue?vue&type=script&lang=js"
export * from "./ImageInfo.vue?vue&type=script&lang=js"

import "./ImageInfo.vue?vue&type=style&index=0&id=b8eb540e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8eb540e"]])

export default __exports__